module.exports = __webpack_public_path__ + "assets/img/en-e53c0ccc.png";